import Cookies from "js-cookie"
import slick from "slick-carousel"
export default {
  init() {
    const globalOverlay = $(".overlay-popup-bottom-layer")
    const popups = $(".overlay-popup")

    if (globalOverlay.length) {
      if (!Cookies.get("overlay_popup")) {
        globalOverlay.addClass("overlay-popup-bottom-layer--active")
      }
    }

    if (popups.length) {
      if (!Cookies.get("overlay_popup")) {
        popups.addClass("overlay-popup--active")
      }

      popups.each((i, e) => {
        const popup = $(e)
        const closeBtn = popup.find(".overlay-popup-close")
        const ctaBtn = popup.find(".overlay-popup-cta")

        const closePopup = () => {
          Cookies.set("overlay_popup", true, { expires: 365 })
          popup.removeClass("overlay-popup--active")
          globalOverlay.removeClass("overlay-popup-bottom-layer--active")
        }
        closeBtn.on("click", closePopup)
        ctaBtn.on("click", closePopup)
      })
    }
  },
}
